import { driver } from "driver.js";
import "driver.js/dist/driver.css";

/**
 * Navega al perfil e inicia el tour de activación como embajador.
 * Si ya está en el perfil, arranca directamente.
 */
export function startTourEmbajador(navigate, uid) {
  const profilePath = `/perfil/${uid}`;

  if (window.location.pathname === profilePath) {
    setTimeout(() => startEmbajadorTourSteps(), 400);
  } else {
    sessionStorage.setItem("aw_pending_tour", "embajador");
    navigate(profilePath);
  }
}

/**
 * Pasos del tour de embajador:
 * 1. Resalta el botón de 3 puntos → el usuario debe pulsarlo para abrir el dropdown.
 * 2. Resalta la opción "Activarme como Embajador" → el usuario debe pulsarla para navegar.
 */
export function startEmbajadorTourSteps() {
  let menuClickHandler = null;
  let optionClickHandler = null;

  const cleanupMenuListener = () => {
    const btn = document.querySelector('[data-tour-id="perfil-menu-trigger"]');
    if (btn && menuClickHandler) {
      btn.removeEventListener("click", menuClickHandler);
      menuClickHandler = null;
    }
  };

  const cleanupOptionListener = () => {
    const opt = document.querySelector('[data-tour-id="menu-activar-embajador"]');
    if (opt && optionClickHandler) {
      opt.removeEventListener("click", optionClickHandler);
      optionClickHandler = null;
    }
  };

  const driverObj = driver({
    showProgress: true,
    nextBtnText: "Siguiente →",
    prevBtnText: "← Anterior",
    doneBtnText: "¡Listo!",
    progressText: "{{current}} de {{total}}",
    allowClose: false,
    onDestroyStarted: () => {
      cleanupMenuListener();
      cleanupOptionListener();
      driverObj.destroy();
    },
    steps: [
      {
        element: '[data-tour-id="perfil-menu-trigger"]',
        popover: {
          title: "⋯ Menú de opciones",
          description:
            "Haz clic en este botón para abrir el menú de opciones de tu perfil.",
          side: "bottom",
          align: "end",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const btn = document.querySelector('[data-tour-id="perfil-menu-trigger"]');
          if (!btn) return;
          menuClickHandler = () => {
            cleanupMenuListener();
            // Esperar a que el dropdown abra con su animación antes de avanzar
            setTimeout(() => driverObj.moveNext(), 400);
          };
          btn.addEventListener("click", menuClickHandler);
        },
        onDeselected: () => {
          cleanupMenuListener();
        },
      },
      {
        element: '[data-tour-id="menu-activar-embajador"]',
        popover: {
          title: "🤝 Activarme como Embajador",
          description:
            "Haz clic aquí para iniciar el proceso de activación como embajador y comenzar a ganar comisiones.",
          side: "left",
          align: "start",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const opt = document.querySelector('[data-tour-id="menu-activar-embajador"]');
          if (!opt) return;
          optionClickHandler = () => {
            cleanupOptionListener();
            // El usuario navega — destruir el tour limpiamente
            driverObj.destroy();
          };
          opt.addEventListener("click", optionClickHandler);
        },
        onDeselected: () => {
          cleanupOptionListener();
        },
      },
    ],
  });

  driverObj.drive();
}
